import { InfoCardList } from '@src/components/InfoCard';
import MemberAvatar from '@src/components/MemberList/MemberAvatar';
import IntlMessages from '@src/util/IntlMessages';

import drawerStyles from './usersSelectionDrawer.module.less';

type AssignedUser = {
  id?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
};

type UsersSelectionDrawerAssignedListProps = {
  users: AssignedUser[];
  onRemoveUser: (userId: string) => void;
  disabled?: boolean;
};

const UsersSelectionDrawerAssignedList = ({
  users,
  onRemoveUser,
  disabled = false,
}: UsersSelectionDrawerAssignedListProps) => {
  return (
    <section className={drawerStyles.assignedSection} aria-label="assigned-users">
      <div className={drawerStyles.assignedSectionHeader}>
        <span className={drawerStyles.assignedSectionLabel}>
          <IntlMessages id="workJourney.assignedUsers" />
        </span>
        <span className={drawerStyles.assignedCount}>
          <span className="material-symbols-outlined" aria-hidden>
            group
          </span>
          {users.length}
        </span>
      </div>

      {users.length === 0 ? (
        <p className={drawerStyles.assignedEmpty}>
          <IntlMessages id="schedule.form.members.modal.users.noUsers" />
        </p>
      ) : (
        <ul className={drawerStyles.assignedList}>
          {users.map(user => {
            const displayName =
              user.name?.trim() || `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();

            return (
              <li key={user.id}>
                <InfoCardList
                  className={drawerStyles.assignedCard}
                  avatar={<MemberAvatar user={user} />}
                  title={displayName}
                  actionButtons={
                    disabled
                      ? []
                      : [
                          {
                            iconButton: 'delete',
                            action: () => user.id && onRemoveUser(user.id),
                            shape: 'circle',
                          },
                        ]
                  }
                />
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default UsersSelectionDrawerAssignedList;
